const destination1 = '/assets/traveltur/Destinations/Home-destination1.png';
const destination2 = '/assets/traveltur/Destinations/Home-destination2.png';
const destination3 = '/assets/traveltur/Destinations/Home-destination3.png';
const destination4 = '/assets/traveltur/Destinations/Home-destination4.png';
const destination5 = '/assets/traveltur/Destinations/Home-destination5.png';
const destination6 = '/assets/traveltur/Destinations/Home-destination6.png';


const gallery1 = '/assets/cormarbus/CormarBus-Gallery-1.png';
const gallery2 = '/assets/cormarbus/CormarBus-Gallery-2.png';
const gallery3 = '/assets/cormarbus/CormarBus-Gallery-3.png';
const gallery4 = '/assets/cormarbus/CormarBus-Gallery-4.png';
const gallery5 = '/assets/cormarbus/CormarBus-Gallery-5.png';
const gallery6 = '/assets/cormarbus/CormarBus-Gallery-6.png';
const gallery7 = '/assets/cormarbus/CormarBus-Gallery-7.png';
const gallery8 = '/assets/cormarbus/CormarBus-Gallery-8.png';

const home1 = '/assets/traveltur/Home/Home-Banner.png';

const destination = [destination1, destination4, destination2, destination3, destination5, destination6];

const gallery = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6, gallery7, gallery8];
const home = [home1];

const travelturSlides = {
  destination,
  gallery,
  home,
};

export default travelturSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/travelturSlides.js